"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const objectSetValueByPath_1 = __importDefault(require("../../shared/objectSetValueByPath"));
const General_1 = require("../../types/General");
const callableObjectBuild = ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.PATH_ENTRIES]: pathEntries, }, }) => {
    let objectBuilded = {};
    if (!pathEntries
        || !(0, ts_validators_1.valueIsArray)(pathEntries)) {
        return objectBuilded;
    }
    pathEntries.forEach((entry) => {
        if (!(0, ts_validators_1.valueIsArray)(entry)) {
            return;
        }
        const [valuePath, value] = entry;
        if (!(0, ts_validators_1.valueIsString)(valuePath)) {
            return;
        }
        objectBuilded = (0, objectSetValueByPath_1.default)(objectBuilded, valuePath.split('.'), value);
    });
    return objectBuilded;
};
exports.default = callableObjectBuild;
